<div class="myField {{highlight}}"
     *ngIf="field"
     [ngClass]="{
        'highlight': active,
        'd-inline-block': !show.label,
        'd-block margin-bottom': (show.value && fieldOptions?.cssClass !== 'd-inline-block'),
        'required': fieldOptions?.required == true
    }">

    <h6 *ngIf="show?.label === true"
        [ngClass]="{
            'title-category': fieldOptions?.category
        }">
        <span *ngIf="fieldOptions?.category"
              class="icon-category"> </span>
        {{fieldOptions?.category || field?.UILabel || field?.DisplayText || 'No title'}}
        <span>
            <button *ngIf="historical.length"
                    #changesEl
                    class="btn btn-sm cv-btn-revised_fields"
                    (click)="showHistorical()">
                <i class="fas fa-book"></i>
                <span>{{ historical.length }}</span>
            </button>
        </span>
    </h6>
    <div *ngIf="show?.label === false">
        <button *ngIf="historical.length"
                #changesEl
                class="btn btn-sm cv-btn-revised_fields"
                (click)="showHistorical()">
            <i class="fas fa-book"></i>
            <span>{{ historical.length }}</span>
        </button>
    </div>

    <!-- <h6 *ngIf="show?.label === true">{{field?.UILabel || field?.DisplayText || 'No title'}}</h6> -->

    <div *ngIf="show.value">
        <p class="text-data"
           [ngClass]="fieldOptions?.cssClass"
           [ngSwitch]="fieldOptions?.displayType">

            <span *ngIf="iconExist">
                <i class="{{icons[icon]}}"></i>
            </span>

            <span *ngSwitchCase="'bool'">
                <span *ngIf="value==='Y' || value === 'True'"><i class="fa fa-check"></i>Yes</span>
                <span *ngIf="value==='N' || value === 'False'"><i class="fa fa-times"></i>No</span>
                <span *ngIf="['--',''].indexOf(value) > -1">--</span>
            </span>

            <span *ngSwitchCase="'bool-with-value'">
                <span>
                    <i class="fa"
                       [ngClass]="{
                            'fa-check': value,
                            'fa-times': !value
                        }"></i> {{ field?.UILabel || field?.DisplayText }}
                </span>
            </span>

            <span *ngSwitchCase="'currency'">
                {{isNumber(value) ? (parseNumeric(value) | currency): value || '--'}}
            </span>
            <span *ngSwitchCase="'thousands-currency'">
                {{isNumber(value) ? ((parseNumeric(value) * 1000) | currency): value || '--'}}
            </span>
            <span *ngSwitchCase="'gla'">{{isNumber(value) ? (value | number): value}} Sq. Ft.</span>
            <span *ngSwitchCase="'years'">{{isNumber(value) ? (value | number): value}} years</span>
            <span *ngSwitchCase="'percentage'">{{value}} %</span>

            <span *ngSwitchDefault>
                <ng-container [ngSwitch]="field.DataType">
                    <ng-container
                                  *ngSwitchCase="['Boolean', 'Bool'].includes(field?.DataType) && value !== null ? field?.DataType : ''">
                        <span>
                            <i class="fa"
                               [ngClass]="{
                                    'fa-check': value,
                                    'fa-times': !value
                                }"></i> {{value ? 'Yes' : 'No'}}
                        </span>
                    </ng-container>

                    <ng-container *ngSwitchDefault>{{value || '--'}}</ng-container>
                </ng-container>
            </span>
        </p>

        <!-- <div>
      <button #changesEl
        *ngIf="historical.length"
        class="btn btn-sm cv-btn-revised_fields"
        (click)="showHistorical()">
        <i class="fas fa-book"></i>
                <span>{{ historical.length }}</span>
      </button>
    </div> -->
    </div>
</div>